import styled from 'styled-components';

import {
  commonSkeletonStyles,
  flexCenterAligned,
  flexColumn
} from '@/styles/common';

export const Wrapper = styled.div<{ $isMobile: boolean }>`
  width: 100%;
  max-width: 520px;
  ${flexColumn}
  gap: 10px;
`;

export const Header = styled.div`
  padding: 4px 0 2px;
`;

export const SkeletonLine = styled.div<{ width?: number; height?: number }>`
  width: ${({ width }) => `${width ? width : 100}%`};
  height: ${({ height }) => `${height ? height : 10}px`};
  border-radius: 28px;
  ${commonSkeletonStyles}
`;

export const Chips = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: max-content;
  gap: 12px;
  overflow: hidden;
`;

export const Chip = styled.div`
  position: relative;
  list-style-type: none;

  min-width: 120px;
  min-height: 107px;
  border-radius: 21px;
  background: var(--bg-card);
  border: 1px solid var(--border-secondary);
  padding: 12px 16px;
  ${flexCenterAligned};
  flex-direction: column;
  gap: 5px;
`;

export const ChipTop = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  min-height: 14px;

  & > ${SkeletonLine} {
    border-radius: 10px;
  }
`;

export const ChipBottom = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  min-height: 20px;

  & > ${SkeletonLine} {
    border-radius: 10px;
  }
`;
